// extracted by mini-css-extract-plugin
export default {"loader_wrap":"LoaderTagList_loader_wrap__rVAG3","loader_item":"LoaderTagList_loader_item__-jZ42","skeleton-loading":"LoaderTagList_skeleton-loading__iZDD+"};